/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Logická jednotka.
 */
class LogicalUnit {
  /**
   * Vytvoří instanci.
   * @param {string} name Název logické jednotky.
   * @returns {LogicalUnit} Nová instance.
   */
  constructor(name) {
    this.name = name;
  }

  /**
   * Vrátí název logické jednotky.
   * @returns {string} název logické jednotky.
   */
  getName() {
    return this.name;
  }
}

export default LogicalUnit;
